module.exports = __webpack_public_path__ + "static/media/example-csat.bbc37fd5.csv";